export default __webpack_public_path__ + "static/media/Group_7_high.1297ee2b.svg";